import React from "react";
import IconProps from "./types";

const ToggleRight: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M2.66667 4.14262e-09C1.98648 -3.7886e-05 1.33199 0.259845 0.837102 0.726474C0.342216 1.1931 0.0443478 1.83121 0.00444317 2.51022L0 2.66667V13.3333C-3.8147e-05 14.0135 0.259845 14.668 0.726474 15.1629C1.1931 15.6578 1.83121 15.9557 2.51022 15.9956L2.66667 16H13.3333C14.0135 16 14.668 15.7402 15.1629 15.2735C15.6578 14.8069 15.9557 14.1688 15.9956 13.4898L16 13.3333V2.66667C16 1.98648 15.7402 1.33199 15.2735 0.837101C14.8069 0.342216 14.1688 0.0443489 13.4898 0.00444455L13.3333 4.14262e-09H2.66667ZM2.66667 1.77778H10.6667V14.2222H2.66667C2.44895 14.2222 2.23881 14.1423 2.07611 13.9976C1.91342 13.8529 1.80947 13.6536 1.784 13.4373L1.77778 13.3333V2.66667C1.77781 2.44895 1.85774 2.23881 2.00241 2.07611C2.14709 1.91342 2.34644 1.80947 2.56267 1.784L2.66667 1.77778ZM4.70489 5.59378C4.55184 5.74684 4.4599 5.95048 4.44632 6.16651C4.43274 6.38253 4.49844 6.59609 4.63111 6.76711L4.70489 6.85067L5.85333 8L4.70489 9.14933C4.55184 9.30239 4.4599 9.50604 4.44632 9.72206C4.43274 9.93808 4.49844 10.1516 4.63111 10.3227L4.70489 10.4062C4.85795 10.5593 5.06159 10.6512 5.27762 10.6648C5.49364 10.6784 5.7072 10.6127 5.87822 10.48L5.96178 10.4062L7.73956 8.62844C7.8926 8.47538 7.98454 8.27174 7.99812 8.05572C8.01171 7.83969 7.946 7.62614 7.81333 7.45511L7.73956 7.37156L5.96178 5.59378C5.79509 5.42714 5.56903 5.33352 5.33333 5.33352C5.09763 5.33352 4.87158 5.42714 4.70489 5.59378Z"
        fill={fill}
      />
    </svg>
  );
};

export default ToggleRight;
